import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import denzaD9Img from '../images/byd-danza-d9.jpeg';
import alphardImg from '../images/toyota-alphard.jpeg';
import stariaImg from '../images/hyundai-staria.avif';
import { Link, Link as RouterLink } from 'react-router-dom';
import bydsealionSpek from '../images/byd-sealion-7-connectivity-24.jpg';
import bydsealionHarga from '../images/byd-sealion-7-connectivity-23.jpg';
import bydsealionRamah from '../images/byd-sealion-7-interior-06.jpg';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

function DenzaD9() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <br />
      <br />
      <br />
      <br />
      <Helmet>
        <title>
          BYD Danza D9 Indonesia: Mobil Listrik Canggih dengan Performa Tinggi
        </title>
        <meta
          name='description'
          content='BYD Danza D9, mobil listrik 2025 untuk rakyat Indonesia. Performa tinggi, desain mewah, dan teknologi canggih kini hadir di BSD Serpong.'
        />
        <meta
          name='keywords'
          content='Danza D9, Danza D9 Indonesia, harga Danza D9, harga Danza D9 2026, Danza D9 NIK 2026, Danza D9 BSD Serpong, Danza D9 Tangerang, Danza D9 Blade Battery 2.0, MPV listrik premium 7 kursi, Danza D9 vs Alphard, Danza sebelumnya Denza, Denza D9 Indonesia, dealer Danza BSD Serpong, BYD BSD Serpong'
        />
        <meta
          property='og:title'
          content='BYD Danza D9 Indonesia: Mobil Listrik Canggih dengan Performa Tinggi'
        />
        <meta
          property='og:description'
          content='Harga, spesifikasi, dan kelebihan BYD Danza D9 mobil listrik MVP 2025 untuk warga Indonesia. Lengkap dengan perbandingan mobil MVP seperti Alphard dan Staria.'
        />
        <meta
          property='og:image'
          content={`https://bydbsdserpong.com${denzaD9Img}`}
        />
        <meta
          property='og:url'
          content='https://bydbsdserpong.com/blog/byd-denzad9-indonesia'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/byd-denzad9-indonesia'
        />
        <meta property='og:type' content='article' />
      </Helmet>

      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        BYD Danza D9: Mobil Listrik MVP Mewah dan Berteknologi Canggih Pesaing
        Alphard dan Staria di pasar Indonesia!
      </Typography>

      <Card sx={{ mb: 5 }}>
        <CardMedia
          component='img'
          height='450'
          image={denzaD9Img}
          alt='BYD Danza D9'
        />
        <CardContent>
          <Typography
            variant='body1'
            sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
          >
            “<strong>BYD Danza D9</strong>” mobil listrik MPV mewah kini resmi
            hadir di Indonesia. Untuk NIK 2026, mobil ini dibanderol{' '}
            <strong>Rp1.080.000.000</strong> OTR Jakarta dengan Blade Battery
            Generasi 2 dan pilihan interior baru <strong>Black</strong>{' '}
            ✨. Danza D9 menghadirkan perpaduan sempurna antara desain elegan
            💎, performa tinggi 🚀, dan teknologi mutakhir ⚙️. Danza D9
            dirancang untuk memenuhi kebutuhan beragam segmen, mulai dari{' '}
            <strong>eksekutif</strong>, <strong>pengusaha</strong>,{' '}
            <strong>layanan VIP</strong>, hingga{' '}
            <strong>keluarga modern</strong> yang mengutamakan kenyamanan,
            efisiensi, dan kesan premium dalam berkendara.
          </Typography>

          <Typography
            variant='body1'
            sx={{ fontSize: '1.1rem', lineHeight: 1.8, mt: 2 }}
          >
            Mengusung teknologi terbaru dari BYD, Danza D9 mampu menempuh hingga{' '}
            <strong>730 kilometer (NEDC)</strong> dalam sekali pengisian daya 🔋. Jarak
            tempuh ini menjadikannya salah satu{' '}
            <strong>mobil listrik 2025</strong> yang paling kompetitif di
            kelasnya.
          </Typography>
        </CardContent>
      </Card>

      {/* Spesifikasi Lengkap */}
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          mb: 6,
          backgroundColor: '#fff3e0',
          border: '2px dashed #fb8c00',
        }}
      >
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          📘 Spesifikasi Lengkap BYD Danza D9 NIK 2026
        </Typography>
        <Typography paragraph>
          <strong>🎨 Varian Warna:</strong> Arctic White, Starry Night Grey,
          Whale Sea Blue, Cosmos Black. Interior: Brown dan Black (baru)
        </Typography>
        <Typography paragraph>
          <strong>💸 Harga:</strong> Rp1.080.000.000 OTR Jakarta (NIK 2026)
        </Typography>
        <Typography paragraph>
          <strong>📏 Dimensi:</strong> 5.250 x 1.960 x 1.900 mm, Radius putar
          5,85 m, bagasi 689 L (2.436 L saat baris 3 dilipat)
        </Typography>
        <Typography paragraph>
          <strong>⚡ Performa:</strong> 340 kW, 365 Nm, FWD, akselerasi 0-100
          km/jam 8,5 detik, Blade Battery Gen 2 115 kWh, jarak tempuh 730 km
          (NEDC), Super Flash Charging 0-97% sekitar 9 menit
        </Typography>
        <Typography paragraph>
          <strong>🛡️ Fitur Keamanan:</strong> DiPilot (ADAS), camera 360° + 3D
          view, airbag, Blind Spot Monitoring (BSD), driver fatigue monitoring,
          child safety locks, ISOFIX child seat mounts, anti-theft device,
          engine immobilizer
        </Typography>
        <Typography paragraph>
          <strong>🛋️ Kenyamanan:</strong> AC, automatic climate control, air
          quality control, layar sentuh 15,6 inch, 16 Devialet speaker
        </Typography>
        <Typography paragraph>
          <strong>🧠 Lainnya:</strong> Sunroof, soundproof, auto-lock, wireless
          charger, 410 liter Up to 1650 liter volume bagasi
        </Typography>
      </Paper>

      <Grid container spacing={3} sx={{ mb: 6 }}>
        <Grid item xs={12} sm={6}>
          <Paper
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: '#f1f8e9',
              borderLeft: '6px solid #7cb342',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h5' fontWeight='bold' gutterBottom>
              ⚙️ Spesifikasi Singkat
            </Typography>
            <Typography>🔋 Motor listrik 308 hp</Typography>
            <Typography>🏎️ Kecepatan maksimal 180 km/jam</Typography>
            <Typography>
              🔌 Baterai LFP (BYD Blade), jarak tempuh 620 km
            </Typography>
            <Typography>📏 Dimensi 5.250 x 1.960 x 1.900 mm</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: '#e3f2fd',
              borderLeft: '6px solid #42a5f5',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h5' fontWeight='bold' gutterBottom>
              🌟 Cocok untuk eksekutif, permbisnis, layanan VIP & keluarga
              modern
            </Typography>
            <Typography>🛋️ Desain Interior: Luas, Nyaman & Stylish</Typography>
            <Typography>🌿 Ramah Lingkungan & Bebas Emisi</Typography>
            <Typography>👨‍👩‍👧‍👦 7-Seater: Nyaman untuk Semua Kalangan</Typography>
            <Typography>
              📱 Fitur Digital: Touchscreen, Smart Mode, Voice Assistant
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <br />
      <br />

      <Paper sx={{ p: 4, borderRadius: 3, mb: 5 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🚘 Hemat Biaya Pakai Mobil Listrik dalam Setahun?
        </Typography>

        <Typography variant='body1' paragraph>
          ⚡ Salah satu keuntungan utama dalam mobil listrik{' '}
          <strong>BYD Danza D9</strong> adalah{' '}
          <strong>biaya operasional yang jauh lebih murah</strong> dibandingkan
          mobil bensin konvensional seperti <strong>Toyota Alphard</strong> dan{' '}
          <strong>Hyundai Staria</strong> ⛽.
        </Typography>

        <Typography variant='h6' fontWeight='bold' gutterBottom>
          📊 Simulasi Biaya Operasional Selama 1 Tahun (1.000 km per bulan)
        </Typography>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>🚗 Jenis Mobil</strong>
                </TableCell>
                <TableCell>
                  <strong>⚡ Biaya Energi / BBM</strong>
                </TableCell>
                <TableCell>
                  <strong>🔧 Biaya Servis</strong>
                </TableCell>
                <TableCell>
                  <strong>💰 Total Biaya</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>BYD Danza D9 (Listrik)</TableCell>
                <TableCell>± Rp2.700.000 🔋</TableCell>
                <TableCell>± Rp2.000.000 🛠️</TableCell>
                <TableCell>
                  <strong>± Rp4.700.000</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Alphard dan Staria</TableCell>
                <TableCell>± Rp13.00.000 ⛽</TableCell>
                <TableCell>± Rp5.000.000 🛠️</TableCell>
                <TableCell>
                  <strong>± Rp18.000.000</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant='body1' mt={3}>
          Dengan menggunakan mobil listrik seperti <strong>BYD Danza D9</strong>
          , kamu bisa hemat hingga <strong>Rp13.300.000 per tahun!</strong>{' '}
          Hemat ini bisa kamu gunakan untuk ✈️ <strong>liburan</strong>, 📈{' '}
          <strong>investasi</strong>, atau 🎁{' '}
          <strong>beli barang impianmu</strong>.
        </Typography>

        <Typography variant='body2' mt={1} color='text.secondary'>
          *Simulasi ini hanya estimasi. Biaya bisa berbeda tergantung tarif
          listrik, harga BBM, dan kondisi kendaraan.
        </Typography>
      </Paper>

      {/* Simulasi Cicilan */}
      <Paper sx={{ p: 4, borderRadius: 3, mb: 5 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Simulasi Cicilan Danza D9 NIK 2026
        </Typography>
        <Typography paragraph>
          Harga Rp1.080.000.000 OTR Jakarta. Dengan DP 20% (sekitar Rp216 juta),
          sisa pembiayaan sekitar Rp864 juta. Besaran angsuran bulanan bergantung
          tenor, suku bunga, dan lembaga pembiayaan yang dipilih.
        </Typography>
        <Typography variant='body2' color='text.secondary' mt={2}>
          *Hubungi Junius untuk simulasi resmi sesuai leasing dan profil
          pembeli.
        </Typography>
      </Paper>

      {/* Perbandingan Harga */}
      <Box
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Perbandingan dengan mobil MVP lain di Indonesia
        </Typography>

        <Grid container spacing={4} justifyContent='center' sx={{ mb: 6 }}>
          {[
            {
              name: 'Toyota Alphard',
              image: alphardImg,
              price: 'Rp1,3 Miliar - Rp1,6 Miliar',
              highlight: '2.5L Hybrid (Bensin + Listrik), 6-Seater, 180 hp',
            },
            {
              name: 'Hyundai Staria',
              image: stariaImg,
              price: 'Rp900 Juta - Rp1,1 Miliar',
              highlight: '3.5L bensin V6, 9-Seater, 175 hp',
            },
          ].map((car, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Card>
                <CardMedia
                  component='img'
                  height='180'
                  image={car.image}
                  alt={car.name}
                />
                <CardContent>
                  <Typography variant='h6' fontWeight='bold'>
                    {car.name}
                  </Typography>
                  <Typography variant='body2' color='text.secondary'>
                    {car.price}
                  </Typography>
                  <Typography variant='body2'>{car.highlight}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Tabel Perbandingan */}
      <Paper sx={{ p: 4, borderRadius: 3, backgroundColor: '#f9f9f9', mb: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🎓 Dari Para Ahli
        </Typography>
        <Typography variant='subtitle1' gutterBottom>
          💡 Wawasan untuk bantu keputusan terbaikmu:
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ mt: 2, border: '2px solid #1976d2', borderRadius: 2 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: '#e3f2fd' }}>
              <TableRow>
                <TableCell>
                  <strong>📌 Kategori</strong>
                </TableCell>
                <TableCell align='center'>
                  <strong>🚗 BYD Danza D9 (EV)</strong>
                </TableCell>
                <TableCell align='center'>
                  <strong>🚙 Toyota Alphard (Hybrid)</strong>
                </TableCell>
                <TableCell align='center'>
                  <strong>🚙 Hyundai Staria (Bensin)</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  👍 Yang Kami Sukai
                </TableCell>
                <TableCell align='center'>
                  <Typography>🔋 Full EV – bebas emisi</Typography>
                  <Typography>🛋️ Interior mewah & captain seat</Typography>
                  <Typography>📲 Layar besar, voice command</Typography>
                  <Typography>💸 Biaya operasional murah</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>🔋 Hybrid hemat BBM</Typography>
                  <Typography>👑 Fitur kenyamanan khas Alphard</Typography>
                  <Typography>🌿 Emisi rendah, brand prestige</Typography>
                  <Typography>🧳 Sangat cocok untuk VIP/family</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>🚐 Kabin sangat luas (7–11 seat)</Typography>
                  <Typography>🎥 Fitur lengkap, desain futuristik</Typography>
                  <Typography>🚗 Performa mesin V6 bertenaga</Typography>
                  <Typography>📦 Bagasi besar & fleksibel</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  👎 Yang Tidak Kami Sukai
                </TableCell>
                <TableCell align='center'>
                  <Typography>⚙️ Jaringan servis EV belum luas</Typography>
                  <Typography>⏱️ Waktu charging relatif lama</Typography>
                  <Typography>🔧 Jaringan aftersales terbatas</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>💰 Harga tertinggi di kelasnya</Typography>
                  <Typography>🛠️ Biaya perawatan premium</Typography>
                  <Typography>📏 Ukuran besar, sulit di parkir</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>🛢️ Konsumsi BBM tinggi</Typography>
                  <Typography>🔈 Kabin kurang senyap</Typography>
                  <Typography>📶 Kurang teknologi sekelas EV</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography
          variant='body1'
          sx={{ fontSize: '1.1rem', lineHeight: 1.5 }}
          mt={4}
        >
          Lebih dari sekadar kendaraan ramah lingkungan🌱,{' '}
          <strong>Danza D9</strong> hadir sebagai simbol gaya hidup baru untuk{' '}
          <strong>mobil listrik MPV</strong> ⚡ yang tidak hanya canggih dan
          hemat energi, tetapi juga memberikan kesan mewah dan stylish bagi
          penggunanya. Dengan semua keunggulan tersebut,{' '}
          <strong>Danza D9</strong> siap bersaing secara langsung dengan{' '}
          <strong>mobil MPV</strong> populer seperti{' '}
          <strong>Toyota Alphard</strong> 👑 dan <strong>Hyundai Staria</strong>{' '}
          🛸, bahkan menawarkan nilai lebih dalam hal inovasi 💡 dan
          keberlanjutan 🌍.
        </Typography>
      </Paper>

      <Paper
        sx={{
          p: 4,
          mt: 8,
          backgroundColor: '#f1f8e9',
          borderLeft: '6px solid #7cb342',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚨 Tertarik dengan BYD Atto1 dan Ingin Segera PO?
        </Typography>
        <Typography variant='body1' gutterBottom>
          Jangan sampai kehabisan! Hubungi Junius sekarang untuk informasi
          lengkap, promo menarik, dan jadwal pre-order unit BYD Danza D9 di
          Indonesia. 💬
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <WhatsAppIcon sx={{ color: '#25D366', marginRight: 2 }} />
            <Typography>
              <a
                href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20mau%20tau%20info%20BYD%20nya'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                0812 8686 4825
              </a>
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <InstagramIcon sx={{ color: '#C13584', marginRight: 2 }} />
            <Typography>
              <a
                href='https://www.instagram.com/bydbsdserpong/'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                @bydbsdserpong
              </a>
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚗 Tertarik dengan Mobil Listrik Lain dari BYD?
        </Typography>
        <Typography variant='body1' gutterBottom>
          Cek juga artikel lainnya yang membahas mobil listrik canggih dari BYD:
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              md: '1fr 1fr 1fr',
            },
            gap: 3,
            mt: 2,
          }}
        >
          {[
            {
              slug: '/blog/spesifikasi-lengkap-byd-sealion-7',
              title: 'Spesifikasi Lengkap BYD Sealion 7',
              image: bydsealionSpek,
            },
            {
              slug: '/blog/harga-byd-sealion-7',
              title:
                'Harga BYD Sealion 7: Apa yang Membuatnya Bernilai Tinggi?',
              image: bydsealionHarga,
            },
            {
              slug: '/blog/byd-sealion-7-ramah-lingkungan',
              title: 'BYD Sealion 7: Mobil Listrik Ramah Lingkungan',
              image: bydsealionRamah,
            },
          ].map((article, index) => (
            <Box
              key={index}
              sx={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                overflow: 'hidden',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                },
              }}
            >
              <Link
                component={RouterLink}
                to={article.slug}
                underline='none'
                sx={{ color: 'inherit', textDecoration: 'none' }}
              >
                <Box
                  component='img'
                  src={article.image}
                  alt={article.title}
                  sx={{ width: '100%', height: '160px', objectFit: 'cover' }}
                />
                <Box sx={{ p: 2 }}>
                  <Typography variant='body1' fontWeight='bold'>
                    {article.title}
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Klik untuk baca lebih lanjut 🔍
                  </Typography>
                </Box>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default DenzaD9;
